import React from 'react';
import { ItineraryDetails, ItineraryDetailsNoPrice } from './ItineraryDetails';
import {
  useItinerarySelector,
  useOffer,
} from '@/providers/PriceFreezeOfferProvider';
import { Box } from '@edreamsodigeo/prisma-design-system';

export function ItineraryDetailsContainer(props) {
  const itinerary = useItinerarySelector((itinerary) => itinerary);
  const offer = useOffer();
  const hasPill = props.hasPill || false;
  const primePriceLabel = props.primePriceLabel;

  return (
    <Box mb="base">
      <ItineraryDetails
        itinerary={itinerary}
        hasPill={hasPill}
        primePriceLabel={primePriceLabel}
        frozenPrice={offer.frozenPrimePrice}
      />
    </Box>
  );
}

export function ItineraryDetailsProductContainer(props) {
  const itinerary = useItinerarySelector((itinerary) => itinerary);
  const hasPill = props.hasPill || false;
  const primePriceLabel = props.primePriceLabel;

  return (
    <Box mb="base">
      <ItineraryDetails
        itinerary={itinerary}
        hasPill={hasPill}
        frozenPrice={props.frozenPrice}
        primePriceLabel={primePriceLabel}
      />
    </Box>
  );
}

export function ItineraryDetailsNoPriceContainer() {
  const itinerary = useItinerarySelector((itinerary) => itinerary);

  return <ItineraryDetailsNoPrice itinerary={itinerary} />;
}
